export default [
  {
    path: '/admin/institution/message/center',
    name: 'InstitutionMessageCenter',
    component: () => import('@/views/message/center'),
    meta: {
      title: '消息中心',
      headType: 2,
      routerType: 2,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/institution/message.js